import React from 'react';
import { Image, Grid, Segment, Button } from 'semantic-ui-react';
import styles from './DesktopRealTalk.styles';
import classes from './DesktopRealTalk.styles.css';
import ShadowSeparator from '../../UI_Elements/ShadowSeparator';
import keyIcon from '../../../../assets/images/key_white.svg';
import Link from '../../../../lib/components/link';

const FooterRealTalk = () => (
  <div>
    <Segment basic style={styles.realTalkLabel}>
      <div style={styles.realTalkLabelText}>
        REAL TALK
      </div>
      <div style={styles.realTalkLabelUnderline} />
    </Segment>
    <ShadowSeparator />
    <Grid columns={3} style={styles.realTalkGrid}>
      <Grid.Row>
        <Grid.Column style={styles.realTalkGridColumn}>
          <div style={styles.quote}>{'\u201C'}</div>
          <blockquote
            style={styles.largeQuoteText}
          >
            If you want to win your league, use The Huddle. It’s that simple.
            <span style={styles.largeQuoteMark}>”</span>
          </blockquote>
          <p style={styles.AttributionNameText}>
            Paul Friel
          </p>
          <p style={styles.AttributionLabelText}>
            WCOFF $200,000 Champion
          </p>
        </Grid.Column>
        <Grid.Column style={styles.realTalkGridColumn}>
          <blockquote
            style={styles.mediumQuoteText}
            className="realTalkBlockQuote"
          >
            I have been a member of The Huddle for 9 years.
            I find The Huddle’s information very helpful...
            The Huddle has the best ‘Ease of Schedule’ ranking system I have ever seen.
            <span style={styles.mediumQuoteMark}>”</span>
          </blockquote>
          <p style={styles.MedAttributionNameText}>
            Kenny Hegmann
          </p>
          <p style={styles.MedAttributionLabelText}>
            Mr. Fantasy Football $35,000 Champion
          </p>
        </Grid.Column>
        <Grid.Column style={styles.realTalkGridColumn}>
          <blockquote
            style={styles.mediumQuoteText}
            className="realTalkBlockQuote"
          >
            I’ve been a Huddle member for two years… This year we took everything: points, record,
            ranking, $$$$$, and the championship! Your timely insights helped us draft{' '}
            and maintain the best team from top to bottom throughout the entire season.
            Thanks a million and see you next season.
            <span style={styles.mediumQuoteMark}>”</span>
          </blockquote>
          <p style={styles.MedAttributionNameText}>
            Jerry Mitchell
          </p>
          <p style={styles.MedAttributionLabelText} />

        </Grid.Column>
      </Grid.Row>
    </Grid>
    <Segment basic textAlign="center" style={styles.fullAccessLabel}>
      <span >
        <Image
          src={keyIcon}
          className={classes.keyIcon}
          inline
        />
        <Link to="/subscribe"><span className={classes.fullAccessLabelText}>Ready to start winning?</span></Link>
        <Link to="/subscribe"><Button className={classes.fullAccessButton}>FULL ACCESS </Button></Link>
      </span>

    </Segment>
  </div>
);

export default FooterRealTalk;



// WEBPACK FOOTER //
// ./src/app/components/Footer/DesktopFooter/DesktopRealTalk.js